import { useState, useEffect } from "react";

const STORAGE_KEY = "announcement-dismissed";

const AnnouncementBar = ({
  message = "We're hiring! Join our team.",
  link = "/team",
  linkText = "Learn more",
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-[#FB5B38] text-white"
      role="banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-2.5 sm:px-6 flex items-center justify-center gap-2 sm:gap-3 relative">
        <p className="text-sm font-outfit text-center leading-snug">
          {message}{" "}
          <a
            href={link}
            className="font-poppins font-medium underline underline-offset-2 hover:opacity-80 transition-opacity"
          >
            {linkText} &rarr;
          </a>
        </p>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss announcement"
          className="absolute right-3 sm:right-5 top-1/2 -translate-y-1/2 p-1 rounded
            hover:bg-white/20 transition-colors
            focus:outline-none focus:ring-2 focus:ring-white/40"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
